import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';

import { useUpsertConversation } from '../../../redux/hooks/answer/conversation-hooks';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks/app-hooks';
import { setActiveConversationId } from '../../../redux/slices/chat-tab/chat-tab-slice';
import { handleTabSwitch } from '../../../redux/thunks/tabs-thunk';
import { Tabs } from '../../../redux/types';

export const useChatBoostModeButton = () => {
    const { t } = useTranslation('translations');
    const { question } = useAppSelector((state) => state.question);
    const dispatch = useAppDispatch();
    const upsertConversation = useUpsertConversation();

    const onClick: React.MouseEventHandler = React.useCallback(
        async (e) => {
            if (e instanceof MouseEvent) {
                e.stopPropagation();
            }

            const conversationId = v4();

            // do not use here the "question" from the state
            // it will trigger unnecessary rerenders
            // the "question" value will be added to the payload in the thunk
            await upsertConversation({ conversationId, boostMode: true });

            dispatch(setActiveConversationId(conversationId));
            dispatch(handleTabSwitch(Tabs.CHAT));
        },
        [dispatch, upsertConversation]
    );

    return {
        onClick,
        enabled: !!question,
        disabled: !question,
        label: t('chat.deep-search'),
    };
};
